import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";

export default function ArticleSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("article.title")}
          </h2>
          <p className="mt-2 text-base text-foreground-600">
            {t("article.subtitle")}
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={t(`articles.${article.slug}.h1`)}
                  title={t(`articles.${article.slug}.h1`)}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                  {t(`articles.${article.slug}.categoryLabel`)}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {t(`articles.${article.slug}.h1`)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  {t(`articles.${article.slug}.subtitle`)}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-time-line"></i>
                    </span>
                    {t(`articles.${article.slug}.readTime`)}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-700">
                    {t("cta.readMore")}
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}